/* eslint-disable prefer-destructuring */
/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable no-unused-expressions */
import { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import H5 from '@base/H5/H5';
import { useSelectorToStore, useDispatchToStore } from '@hooks/reduxHooks';
import Cookies from '@utils/cookies';
import { setDarkMode } from '@actions/auth';

const StyIframe = styled.iframe`
  border: 0 none transparent;
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0px;
  left: 0px;
  z-index: 3;
`;

const WrapperDiv = styled.div`
  grid-column: 1/25;
  justify-content: center;
  display: flex;
`;

const getParameterByName = (name) => {
  const url = window.location.href;
  const newName = name.replace(/[[\]]/g, '\\$&');
  const regex = new RegExp(`[?&]${newName}(=([^&#]*)|&|#|$)`);
  const results = regex.exec(url);
  if (!results) return undefined;
  if (results[2] === undefined) return undefined;
  return decodeURIComponent(results[2].replace(/\+/g, ' '));
};

const EducatorLiveclass = ({ courseUID, classUID }) => {
  const mapStateToProps = ({ educator, auth, courses, items }) => ({
    liveClassData: educator.liveClassData,
    accessToken: auth.accessToken,
    isDriveEnabled: auth?.accessControl?.is_drive_enabled,
    courseData: courses?.data[courseUID],
    classData: items?.data[classUID]
  });
  const dispatch = useDispatchToStore();
  const [showIframe, setIframe] = useState(false);
  const props = useSelectorToStore(mapStateToProps);
  const {
    liveClassData,
    accessToken,
    isDriveEnabled,
    courseData,
    classData
  } = props;
  const liveClassURL = liveClassData?.live_class_url;
  const onMessageReceived = (e) => {
    if (e.data && window.parent && window.parent !== window) {
      window.parent.postMessage(e.data, '*');
    }
    if (e.data.liveClassReady) {
      const isDarkModeOn = Cookies.readCookie('isDarkModeOn') || false;
      document.getElementById('nativeIframe')?.contentWindow?.postMessage(
        {
          lessonData: {
            isDriveEnabled,
            accessToken,
            data: {
              ...liveClassData,
              isEnrolled: courseData?.isEnrolled,
              programmeType: courseData?.courseType,
              isSaved: classData?.isSaved,
              isCanvasModeDisabled: getParameterByName('isCanvasModeDisabled')
            }
          },
          isDarkModeOn,
          apiHost: process.env.BACKEND_URL.slice(0, -1)
        },
        '*'
      );
    }

    if (e.data.setDarkModeOn) {
      Cookies.setCookie(
        'isDarkModeOn',
        e.data.setDarkModeOn.shouldSet ? 'true' : ''
      );
      dispatch(setDarkMode(e.data.setDarkModeOn.shouldSet));
      // [TODO] Once dark mode is supported on educator side
      // toggleDarkMode(e.data.setDarkModeOn.shouldSet);
    }
  };
  useEffect(() => {
    window.addEventListener('message', onMessageReceived);
    setIframe(true);
    return () => window.removeEventListener('message', onMessageReceived);
  }, []);
  return (
    <WrapperDiv>
      {liveClassURL && showIframe ? (
        <StyIframe
          id="nativeIframe"
          autoPlay
          quality="high"
          allow="microphone; camera"
          src={liveClassURL}
          webkitallowfullscreen="true"
          allowFullScreen
          frameBorder="no"
        />
      ) : null}
      {(!liveClassURL || !liveClassData) && <H5> No Live class found</H5>}
    </WrapperDiv>
  );
};

export default EducatorLiveclass;

EducatorLiveclass.propTypes = {
  liveClassData: PropTypes.objectOf(PropTypes.any),
  accessToken: PropTypes.string,
  courseUID: PropTypes.string.isRequired,
  classUID: PropTypes.string.isRequired,
  isDriveEnabled: PropTypes.bool,
  courseData: PropTypes.objectOf(PropTypes.any),
  classData: PropTypes.objectOf(PropTypes.any)
};

EducatorLiveclass.defaultProps = {
  liveClassData: null,
  accessToken: null,
  isDriveEnabled: false,
  courseData: {},
  classData: {}
};
